import { IPaginatedResponse, IResponse } from '../../model';
import { Response } from '../../../model';
import ServiceBase from '../../servicebase';
import { IClienteCotizador } from './model/IClienteCotizador';
import { SubcuentasReporteOut } from '../../../model/clientes';

/*
interface IServiceDashboard {
  widget: (widget:string, data:any) => Promise<IResponse<{ data: any[], config: any, userConfig: any }>>;
  removeWidget: (widget:string) => Promise<IResponse<any>>;

  chartpie_cotizaciones: (data:{ idcliente?: number }) => Promise<IResponse<any[]>>;
  chartbar_cotizaciones: (data:{ idcliente?: number }) => Promise<IResponse<any>>;
  chartbar_comisiones: (data:{ idcliente?: number }) => Promise<IResponse<any>>;
  chartDoughnut_operacionesMedioPago: (data:{ idcliente?: number }) => Promise<IResponse<any>>;
  chartbar_operacionesMedioPago: (data:{ idcliente?: number }) => Promise<IResponse<any>>;
  chartradar_operaciones_cotizaciones: (data:{ idcliente?: number }) => Promise<IResponse<any>>;
}
*/
class TableroService extends ServiceBase {

  cards = (model: { estados: string, fromupdate?: string }) : Promise<IPaginatedResponse<any>> => 
    this.GetFetch<IPaginatedResponse<any>>('reporte/tablero/cards', model)

}

class Widget extends ServiceBase {
  /** devuelve la lista de widgets disponibles para un usuario */
  widgets = (data?: { getall?: boolean }) => 
    this.GetFetch<IResponse<any[]>>(`reporte/dashboard/widgets`, data ?? {});

  /** devuelve la información de un widget */
  widget = (widget:string, data:any) => 
    this.GetFetch<IResponse<{ data: any[], config: any, userConfig: any }>>(`reporte/dashboard/widget/${widget}/`, data);

  /** devuelve la información de un widget */
  updateConfig = (widget:string, config:any) => 
    this.PostFetch<IResponse<{ data: any[], config: any, userConfig: any }>>(`reporte/dashboard/widget/${widget}/`, config);

  /** eliminar un widget del tablero del usuario logueado */
  remove = (widget:string) => 
    this.DeleteFetch<IResponse<any>>(`reporte/dashboard/widget/${widget}`, {});
    
  /** recupera un widget del tablero del usuario logueado */
  restore = (widget:string) => 
    this.DeleteFetch<IResponse<any>>(`reporte/dashboard/widget/restore/${widget}`, {});
}

interface IServiceAudit {
  usuario: (data:{ creafechaDesde?: Date, creafechaHasta?: Date, idusuario?: number, top?: number }) => Promise<IPaginatedResponse<any>>;
  entidad: (data:{ creafechaDesde?: Date, creafechaHasta?: Date, entidad:string, idusuario?: number, top?: number }) => Promise<IPaginatedResponse<any>>;
}
export default class ReportesService extends ServiceBase {
  constructor(api: string) {
    super(api);
    
    this.widget = new Widget(api);
    this.tablero = new TableroService(api);
    
/*
    this.dashboard = {
      widget: (widget:string, data:any) => 
        this.GetFetch<IResponse<{ data: any[], config: any, userConfig: any }>>(`reporte/dashboard/widget/${widget}/`, data),

      removeWidget: (widget:string) => 
        this.DeleteFetch<IResponse<any>>(`reporte/dashboard/removewidget/${widget}`, {}),

      chartpie_cotizaciones: (data:{ idcliente?: number }) => 
        this.GetFetch<IResponse<any[]>>('reporte/dashboard/chartpie_cotizaciones', data),
        
      chartbar_cotizaciones: (data:{ idcliente?: number }) => 
        this.GetFetch<IResponse<any>>('reporte/dashboard/chartbar_cotizaciones', data),

      chartbar_comisiones: (data:{ idcliente?: number }) => 
        this.GetFetch<IResponse<any>>('reporte/dashboard/chartbar_comisiones', data),

      chartDoughnut_operacionesMedioPago: (data:{ idcliente?: number }) => 
        this.GetFetch<IResponse<any>>('reporte/dashboard/chartDoughnut_operacionesMedioPago', data),

      chartbar_operacionesMedioPago: (data:{ idcliente?: number }) => 
        this.GetFetch<IResponse<any>>('reporte/dashboard/chartbar_operacionesMedioPago', data),
      
      chartradar_operaciones_cotizaciones: (data:{ idcliente?: number }) => 
        this.GetFetch<IResponse<any>>('reporte/dashboard/chartradar_operaciones_cotizaciones', data),
    }
    */

    this.audit = {
      usuario: (data:{ creafechaDesde?: Date, creafechaHasta?: Date, idusuario?: number }) => 
        this.GetFetch<IPaginatedResponse<any>>('reporte/audit/usuario', data),

      entidad: (data:{ creafechaDesde?: Date, creafechaHasta?: Date, entidad:string, idusuario?: number, top?: number }) => 
        this.GetFetch<IPaginatedResponse<any>>('reporte/audit/entidad', data),
    }
  }
    
  //dashboard: IServiceDashboard;
  widget: Widget;
  audit: IServiceAudit;
  tablero: TableroService;
  

  emailenviado = (model: { pageIndex?: number, pageSize?: number, sort?: string, creafechaDesde:string, creafechaHasta: string, tipo?: string, operationNumber?: string, from?: string, email?:string }) : Promise<IPaginatedResponse<any>> => 
    this.GetFetch<IPaginatedResponse<any>>('reporte/emailenviado', model)
    
  micuenta = (data:{ idcliente?: number }) : Promise<IResponse<any>> => 
    this.GetFetch<IResponse<any>>('reporte/micuenta', data);

  cotizadores = (data:{ idcliente?: number }) : Promise<IResponse<IClienteCotizador[]>> => 
    this.GetFetch<IResponse<IClienteCotizador[]>>('reporte/cotizadores', data);
    
  AdminReporteOperaciones = (data: any) : Promise<IPaginatedResponse<any>> => 
    this.PostFetch<IPaginatedResponse<any>>('reporte/admin/reporte-operaciones', data);

  // migrado reing
  subcuentas = (data:{ activo?: boolean }) : Promise<Response<SubcuentasReporteOut[]>> => 
    this.GetFetch<Response<SubcuentasReporteOut[]>>('clientes/cliente/subcuentas', data);

}